import React from 'react';
import PropTypes from 'prop-types';
import AdaptiveTrait from '../../AdaptiveTrait';
import css from '@src/styles/elements/table.scss';

export default class Table extends React.Component {

    constructor(props) {

        super(props);

        new AdaptiveTrait(this);
    }

    static get propTypes() {

        return {
            children: PropTypes.any,
            className: PropTypes.string,
            responsible: PropTypes.bool,
        };
    }

    renderMobile() {

        const classes = [css['table']];

        if (this.props.className)
            classes.push(this.props.className);

        return (
            <div className={ (this.props.responsible ?? true) ? css['table-responsive'] : null }>
                <table className={ classes.join(' ') }>{ this.props.children }</table>
            </div>
        );
    }

    renderDesktop() {

        return this.renderMobile();
    }

}